/**
 * Estados cujo valor ainda nao esta no saldo informado. Fonte unica para o
 * dominio e para as consultas SQL da API.
 */
export const ESTADOS_QUE_ABATEM = [
    "reservado",
    "contratado",
    "enviado",
    "divergente",
    "aguardando_retirada",
];
/**
 * Chave de comparacao da folha funcional (FF). O arquivo pode trazer `03` e o
 * cadastro `3`; a chave e' a mesma. O valor original continua sendo o que se
 * escreve nos arquivos.
 */
export function chaveFolha(ff) {
    return semZerosAEsquerda(ff);
}
/**
 * Identidade sem zeros a esquerda: `001476` -> `1476`, `07` -> `7`, `0` -> `0`.
 * E' a regra da chave da folha E da matricula — a ALECE passou a completar as
 * duas com zeros em 202609, e o banco guarda sem. Uma funcao so', para a borda
 * (layouts) e a chave de comparacao nunca divergirem.
 */
export function semZerosAEsquerda(valor) {
    return (valor ?? "").trim().replace(/^0+(?=\d)/, "");
}
/**
 * Chave de comparacao da matricula. A consignataria escreve `001476` e a ALECE
 * `1476`: sem esta chave a mesma pessoa virava duas consignacoes e o desconto
 * saia em dobro (incidente AMT/IMAMN, 14/09/2026). O valor gravado e' o do
 * cadastro; a chave so' compara.
 */
export function chaveMatricula(matricula) {
    return semZerosAEsquerda(matricula);
}
export function compromissoAindaAbate(c) {
    return ESTADOS_QUE_ABATEM.includes(c.estado);
}
/**
 * `residuosCentavos` e' a soma dos residuos VALOR-PAGOFP dos grupos ja
 * considerados. Pertence ao grupo, nao a cada compromisso dele: um grupo de tres
 * contratos com R$ 100 de residuo abate R$ 100, nao R$ 300.
 */
export function calcularMargemInformada(saldoInformadoCentavos, compromissos, residuosCentavos = 0) {
    if (!Number.isSafeInteger(saldoInformadoCentavos))
        throw new Error("saldo informado precisa estar em centavos");
    if (!Number.isSafeInteger(residuosCentavos) || residuosCentavos < 0)
        throw new Error("residuo invalido");
    let pendentes = 0;
    const residuos = residuosCentavos;
    for (const c of compromissos) {
        if (!Number.isSafeInteger(c.valorMensalCentavos) || c.valorMensalCentavos < 0) {
            throw new Error(`compromisso ${c.id} possui valor mensal invalido`);
        }
        if (compromissoAindaAbate(c))
            pendentes += c.valorMensalCentavos;
    }
    const real = saldoInformadoCentavos - pendentes - residuos;
    return {
        saldoInformadoCentavos,
        compromissosPendentesCentavos: pendentes,
        residuosCentavos: residuos,
        saldoRealCentavos: real,
        disponivelCentavos: Math.max(0, real),
    };
}
/** Um grupo so prova incorporacao quando valor e composicao conferem. */
export function grupoFoiConsiderado(enviado, retorno) {
    return retorno.quantidade !== null
        && enviado.quantidade === retorno.quantidade
        && enviado.valorCentavos === retorno.valorCentavos;
}
/** Parcial sem CORTE precisa continuar abatido; com CORTE o saldo ja usa DESCREAL. */
export function residuoDoRetorno(valorCentavos, pagoCentavos, corte) {
    if (corte || pagoCentavos >= valorCentavos)
        return 0;
    return Math.max(0, valorCentavos - pagoCentavos);
}
//# sourceMappingURL=margem-informada.js.map